import template from './ranking.html'
import controller from './ranking.controller'
import './ranking.scss'

let module = angular.module('ranking', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.ranking', {
			url: '/ranking',
			views: {
				'tab-search': {
					template: template,
					controller: controller,
					controllerAs: 'ranking'
				}
			}
		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/ranking/ranking.js